import React, { Fragment, useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Link from '@material-ui/core/Link'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import { makeStyles } from '@material-ui/core/styles'
import { blue, orange } from '@material-ui/core/colors'
import { Link as RouterLink } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { clearServerErrors, getServerError } from 'utils/form'
import useTranslation from 'Hooks/useTranslation'

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(2),
        backgroundColor: orange['A200'],
        marginBottom: theme.spacing(2)
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1)
    },
    wrapper: {
        margin: theme.spacing(3, 0, 2),
        position: 'relative',
    },
    buttonProgress: {
        color: blue[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    visibilityIcon: {
        fontSize: 12,
    },
    eyeButton: {
        padding: 6,
    },
}))

const DashboardLink = React.forwardRef((props, ref) => <RouterLink innerRef={ref} to="/" {...props} />)

const ChangePasswordForm = ({ handleSubmit, register, onSubmit, request }) => {
    const translation = useTranslation();
    const classes = useStyles()

    const [errors, setErrors] = useState(null)
    const [showOldPassword, setShowOldPassword] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    useEffect(() => {
        if (!request.error) return
        if (request.error.errors && Object.keys(request.error.errors).length) {
            setErrors(request.error.errors)
        } else {
            setErrors(null)
        }
    }, [request.error, setErrors])

    const eyeAdornment = (show, toggle) => (
        <InputAdornment position="end">
            <IconButton
                aria-label={show ? 'Hide password' : 'Show password'}
                className={classes.eyeButton}
                onClick={toggle}
            >
                {show
                    ? <VisibilityOff className={classes.visibilityIcon} />
                    : <Visibility className={classes.visibilityIcon} />
                }
            </IconButton>
        </InputAdornment>
    )

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form} noValidate>
            <Fragment>
                <TextField
                    inputRef={register}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="oldPassword"
                    label={translation.changePasswordPageOldPasswordLabel}
                    type={showOldPassword ? 'text' : 'password'}
                    id="oldPassword"
                    onFocus={() => setErrors(errors => clearServerErrors(errors, 'oldPassword'))}
                    error={!!getServerError(errors, 'oldPassword')}
                    helperText={getServerError(errors, 'oldPassword')}
                    InputProps={{ endAdornment: eyeAdornment(showOldPassword, () => setShowOldPassword(v => !v)) }}
                />
                <TextField
                    inputRef={register}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label={translation.changePasswordPagePasswordLabel}
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    onFocus={() => setErrors(errors => clearServerErrors(errors, 'password'))}
                    error={!!getServerError(errors, 'password')}
                    helperText={getServerError(errors, 'password')}
                    InputProps={{ endAdornment: eyeAdornment(showPassword, () => setShowPassword(v => !v)) }}
                />
                <TextField
                    inputRef={register}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="confirmPassword"
                    label={translation.changePasswordPageConfirmPasswordLabel}
                    type={showConfirmPassword ? 'text' : 'password'}
                    id="confirmPassword"
                    onFocus={() => setErrors(errors => clearServerErrors(errors, 'confirmPassword'))}
                    error={!!getServerError(errors, 'confirmPassword')}
                    helperText={getServerError(errors, 'confirmPassword')}
                    InputProps={{ endAdornment: eyeAdornment(showConfirmPassword, () => setShowConfirmPassword(v => !v)) }}
                />
                <div className='btnHolder fullWidthMobile mt22'>
                    <div className="part">
                        <Link component={DashboardLink} className='linkPrimary'>
                            {translation.changePasswordPageBackLabel}
                        </Link>
                    </div>
                    <div className="part">
                        <Button
                            disabled={request.loading}
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                        >
                            {translation.changeButtonLabel}
                        </Button>
                        {request.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </div>
            </Fragment>
        </form>
    )
}

ChangePasswordForm.defaultProps = {
    values: {},
    errors: {},
}

export default ChangePasswordForm
